import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { Check, CheckCircle2 } from 'lucide-react'
import * as React from 'react'

import { cn } from 'src/shared/utils/cn'

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
    variant?: 'default' | 'button'
    children?: React.ReactNode
  }
>(({ className, variant = 'default', children, ...props }, ref) => {
  const styles = {
    default:
      'peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground',
    button:
      'peer flex w-full items-center rounded-lg border bg-background p-4 ring-offset-background hover:bg-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-primary data-[state=checked]:bg-primary/5',
  }

  if (variant === 'button') {
    return (
      <CheckboxPrimitive.Root ref={ref} className={cn(styles[variant], className)} {...props}>
        {children}
        <div className="ml-auto pl-2">
          <CheckboxPrimitive.Indicator>
            <CheckCircle2 className="size-4 text-primary" />
          </CheckboxPrimitive.Indicator>
          {!props.checked && <CheckCircle2 className="size-4 text-primary/35" />}
        </div>
      </CheckboxPrimitive.Root>
    )
  }

  return (
    <CheckboxPrimitive.Root ref={ref} className={cn(styles[variant], className)} {...props}>
      <CheckboxPrimitive.Indicator className="flex items-center justify-center text-current">
        <Check className="size-4" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
})
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
